import { render, staticRenderFns } from "./CandidateCareerPage.vue?vue&type=template&id=2556174d"
import script from "./CandidateCareerPage.vue?vue&type=script&lang=js"
export * from "./CandidateCareerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports